import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useTmpAuthAtom from "shared/model/useConfrimCookie"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostUtilSmsConfirm = (countryCodeRef, contactRef, codeRef) => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, setTmpToken] = useTmpAuthAtom()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("POST", "/util/sms/confirm", {
            "international_number": countryCodeRef?.current,
            "contact": contactRef?.current?.value,
            "confirm_number": codeRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setTmpToken(fetchResult?.data?.confirm_token)
                break
            case 400:
                if (fetchResult?.data?.error_code === "international_number") setAlert("국제번호 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "contact") setAlert("연락처 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "confirm_number") setAlert("인증번호 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 401:
                if (fetchResult?.data?.error_code === 1) setAlert("인증번호가 일치하지 않거나\n인증 시간이 만료되었습니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostUtilSmsConfirm